<h2 mat-dialog-title>Message</h2>

<mat-dialog-content class="mat-typography">
    <p>{{data.message}}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</mat-dialog-actions>